import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../Header';
import { Card, Row, Col, ListGroup, Container, Badge, Table, Alert } from 'react-bootstrap'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines } from '@fortawesome/free-solid-svg-icons';

const UserInfo = () => {
    const [user, setUser] = useState({});  
    const [plans, setPlans] = useState([]);  
    const [planName, setPlanName] = useState('');  
    const [managers, setManagers] = useState([]);  
    const [managerName, setManagerName] = useState('');  
    const [paymentHistory, setPaymentHistory] = useState([]); 
    const [phone, setPhone] = useState(null);
    const [web, setWeb] = useState(null);
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [generatedInvoices, setGeneratedInvoices] = useState(() => {
    const saved = localStorage.getItem("generatedInvoiceIds");
    return saved ? JSON.parse(saved) : [];
    });
    
    // Fetch user data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/users/${id}`);
                
                if (!response.ok) {
                    throw new Error('Failed to fetch user data');
                }
                const userData = await response.json();
                //console.log(userData);
                const userPhone = userData.phone;
                setPhone(userPhone); 
                setUser(userData);  
                //console.log(userData);   
                setLoading(false);  
            } catch (error) {
                console.error(error);
                setLoading(false);  
            }
        };

        fetchData();
    }, [id]);

    useEffect(() => {
        if (phone) { // Check if phone is available before making the API request
            const fetchWeb = async () => {
                try {
                    const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/icicitransaction/${phone}`);    
                    if (!response.ok) {
                        throw new Error('Failed to fetch transaction data');
                    }
                    const webData = await response.json();
                    setWeb(webData || []);
                } catch (error) {
                    console.error(error);
                }
            };    
            fetchWeb();
        }
    }, [phone]);

    // Fetch available plans
    useEffect(() => {
        const fetchPlans = async () => {
            try {
                const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/userdetails/${id}`);                
                if (!response.ok) {
                    throw new Error('Failed to fetch plans');
                }
                const plansData = await response.json();
                setPlans(plansData.userdetails);  
                console.log(plansData);
            } catch (error) {
                console.error(error);
            }
        };

        fetchPlans();
    }, []);

    // Fetch managers data
    useEffect(() => {
        const fetchManagers = async () => {
            try {
                const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/managers');
                
                if (!response.ok) {
                    throw new Error('Failed to fetch managers');
                }
                
                const managersData = await response.json();
                setManagers(managersData.manager); 
            } catch (error) {
                console.error(error);
            }
        };

        fetchManagers();
    }, []);    

    // Fetch payment history data
    useEffect(() => {
        const fetchPaymentHistory = async () => {
            try {
                const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/viewtransaction/${id}`);
                
                if (!response.ok) {
                    throw new Error('Failed to fetch payment history');
                }

                const paymentData = await response.json();
                setPaymentHistory(paymentData);  // Store the fetched payment history
                
                console.log(paymentData);
            } catch (error) {
                console.error(error);
            }
        };

        fetchPaymentHistory();
    }, [id]);

    // Find the user's plan name based on the plan ID
    useEffect(() => {
        if (user.plan && plans.length > 0) {
            const userPlan = plans.find(plan => plan.id === user.plan);
            if (userPlan) {
                setPlanName(userPlan.plan);  
            }
        }
    }, [user.plan, plans]);

    // Find the manager's name based on the mgr_id
    useEffect(() => {
        if (user.mgr_id && managers.length > 0) {
            const userManager = managers.find(manager => manager.id === user.mgr_id);
            if (userManager) {
                setManagerName(userManager.name);  
            }
        }
    }, [user.mgr_id, managers]);


    const handleGenInvoice = async (id) => {
        setLoading(true);
        try {
            if (!id) {
            console.error('Invalid plan ID');
            setLoading(false);
            return;
            }

            const url = `https://apiaksharaconnect.aksharafinalytics.in/inv/${id}`;
            const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            });

            if (!response.ok) {
            const errorData = await response.json();
            console.error("Error response:", errorData);
            throw new Error(`Network response was not ok. Status: ${response.status}`);
            }

            const data = await response.json();
            alert('Invoice has been sent successfully!');

            // Mark this invoice as generated
            const updated = [...generatedInvoices, id];
            setGeneratedInvoices(updated);
            localStorage.setItem("generatedInvoiceIds", JSON.stringify(updated));
        } catch (error) {
            console.error('Error occurred:', error);
            alert('Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
        };



    if (loading) {
        return <div> <span  className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" ></span></div>;  
    }

    return (
        <>
            <Header />
            <Container className="mt-5">
                <Row className="justify-content-center">
                    <Col md={12} lg={12}>
                        <Card>
                            <Card.Body>
                                {/* User name and status */}
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                <h5><b>{user?.company ? user.company.charAt(0).toUpperCase() + user.company.slice(1) : ''}</b></h5>

                                    
                                </div>

                                {/* User Contact Information and Renewal & Dates Side by Side */}
                                <Row>
                                    <Col sm={12} md={6}>
                                        <ListGroup variant="flush">
                                            <ListGroup.Item><strong>Authorized Name:</strong> {user.name}</ListGroup.Item>
                                            <ListGroup.Item><strong>Email:</strong> {user.email}</ListGroup.Item>
                                            <ListGroup.Item><strong>Phone:</strong> {user.phone}</ListGroup.Item>
                                            
                                        </ListGroup>
                                    </Col>

                                    <Col sm={12} md={6}>
                                        <ListGroup variant="flush">
                                            <ListGroup.Item><strong>Address:</strong> {user.address}</ListGroup.Item>
                                            <ListGroup.Item><strong>Manager:</strong> {managerName }</ListGroup.Item>
                                            <ListGroup.Item><strong>Source:</strong> {user.source}</ListGroup.Item>
                                        </ListGroup>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={12} lg={12} className='mt-2'>
                        <Card>
                            <Card.Body>
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5>Package Details</h5>                                    
                                </div>
                                {plans && plans.length > 0 ? (
                                    plans.map((plan, index) => (
                                        <Card key={index} className="mb-3">
                                            <Card.Body>
                                                <Row>
                                                    <Col sm={12} md={6}>                                   
                                                        <ListGroup variant="flush">                                        
                                                            <ListGroup.Item><strong>Service:</strong> {plan.service_name}</ListGroup.Item>    
                                                            <ListGroup.Item><strong>Plan:</strong> {plan.plan_name}</ListGroup.Item>
                                                        </ListGroup>
                                                    </Col>

                                                    <Col sm={12} md={6}>
                                                        <ListGroup variant="flush">
                                                            <ListGroup.Item>
                                                                <strong>Renewal Date:</strong> {plan.renewal_date ?? 'N/A'}   &nbsp;&nbsp;
                                                                {/* {plan.service_name === "Accounting And Bookkeeping Services" && (
                                                                    <a href={`https://apiaksharaconnect.aksharafinalytics.in/inv/${plan.id}/proforma`} className="btn btn-primary " title="Proforma Invoice" target="_blank" rel="noopener noreferrer">
                                                                        Proforma Invoice
                                                                    </a>
                                                                )} */}

                                                            </ListGroup.Item>
                                                            <ListGroup.Item><strong>Total Amount:</strong> ₹ {plan.total_amount} /-</ListGroup.Item>
                                                            <ListGroup.Item>
                                                                <strong>Due Amount:</strong> ₹ {plan.due} /-  
                                                                {plan.due === '0' ? (
                                                                    <button type="button" className="btn btn-warning p-1 m-1 d-flex align-items-center" onClick={() => handleGenInvoice(plan.id)}
                                                                        disabled={loading || generatedInvoices.includes(plan.id)} title="invoice" >
                                                                        {loading ? (
                                                                        <>
                                                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                            Generating...
                                                                        </>
                                                                        ) : generatedInvoices.includes(plan.id) ? (
                                                                        'Generated'
                                                                        ) : (
                                                                        'Generate Invoice'
                                                                        )}
                                                                    </button>
                                                                    ) : (
                                                                    <span></span>
                                                                    )}
                                                                </ListGroup.Item>
                                                        </ListGroup>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    ))
                                ) : (
                                    <p>Loading Plans...</p>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Payment Information Table OUTSIDE of the Card */}
                <Row className="justify-content-center mt-4">
                    <Col md={8} lg={12}>
                        {/* Payment History Table */}
                        <Card.Subtitle className="mt-3 mb-2 text-muted">Payment History</Card.Subtitle>
                        {paymentHistory.length > 0 ? (
                            <Table striped bordered hover responsive>
                                <thead>
                                    <tr>
                                    <th>S.no</th>
                                        <th>Service</th>
                                        <th>Plan </th>
                                        <th>Mode</th>
                                        <th>Total Amount</th>
                                        <th>Paid Amount</th>                                        
                                        <th>Remarks</th>
                                        <th>status</th>
                                        <th>Month</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paymentHistory.map((transaction, index) => {
                                        // Find the corresponding plan name from the plans array
                                        const plan = plans.find(plan => plan.id === transaction.plan_id);
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{transaction.ServiceName}</td> 
                                                <td>{transaction.PlanName}</td>
                                                <td>{transaction.payment_mode}</td>
                                                <td>{transaction.totalAmount }</td>
                                                <td>₹ {transaction.paid_amount}</td>                                                                                                 
                                                <td>{transaction.remarks}</td>                                                
                                                <td>
                                                <Badge className={ transaction.paymentstatus === "Partially" ? "badge bg-warning" : transaction.paymentstatus === "Paid Fully"  ? "badge bg-success" : "badge bg-secondary" } >
                                                    {transaction.paymentstatus} 
                                                </Badge>
                                                </td>
                                                <td>{transaction.pmonth}</td> 
                                                <td>{transaction.dop}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        ) : (
                            <Alert variant="info">No payment history available.</Alert>
                        )}
                    </Col>
                </Row>

                <Row className="justify-content-center mt-4">
                    <Col md={8} lg={12}>
                        {/* Payment History Table */}
                        <Card.Subtitle className="mt-3 mb-2 text-muted">Web Payment History</Card.Subtitle>
                        {Array.isArray(web) && web.length > 0 ? (
                            <Table striped bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th>S.no</th>
                                        <th>Payment Mode</th>
                                        <th>Amount</th>
                                        <th>Transaction ID</th>
                                        <th>Payment Status</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {web.map((payment, index) => {
                                        // Assuming 'plans' is defined and accessible in your code
                                        const plan = plans.find(plan => plan.id === payment.plan_id); // Adjust `payment.plan_id` if needed
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>Online</td>
                                                <td>₹ {payment.amount}</td>
                                                <td>{payment.transaction_id}</td>
                                                <td>{payment.status}</td>
                                                <td>{payment.t_date}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        ) : (
                            <Alert variant="info">No Online payment history available.</Alert>
                        )}
                    </Col>
                </Row>


            </Container>
        </>
    );
}

export default UserInfo;
